// extracted by mini-css-extract-plugin
module.exports = {"learnMore":"learnMore-module__learnMore___XNq3d"};